'use strict';
import angular from 'angular';
import './scripts/feedbacks.directives';
import './scripts/feedbacks.services';

angular.module('feedbacks', [
    'feedbacks.directives',
    'feedbacks.services'
])